// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.google.com/noto/specimen/Noto+Kufi+Arabic?lang=ar_Arab);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".titl[data-v-3e5664ba]{font-family:Noto Kufi Arabic,sans-serif}.reviews-section[data-v-3e5664ba]{margin-top:20px}.hel[data-v-3e5664ba]{margin-right:auto;margin-left:auto}@media (min-width:935px){.hel[data-v-3e5664ba]{display:flex;justify-content:center}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
